import { AxiosResponse, CancelToken } from 'axios';
import { CreatedUpdatedTable } from '../../utils/APIReturnTypes';
import AxiosConfig from '../../utils/AxiosConfig';
import { CreditCardTransactionAssignment } from '../creditCards/CreditCardAPI';

const axiosInstance = AxiosConfig.instance();

/*-------------------------------------Files----------------------------------------------*/
export function getFiles(token: CancelToken): Promise<FileUploads[]> {
  const url = '/company/files';

  var config: any = {};

  if (token !== undefined) {
    config.cancelToken = token;
  }

  return axiosInstance.get(url, config).then((r) => r.data);
}

export function getUserFiles(userId: string, token?: CancelToken): Promise<FileUploads[]> {
  const url = '/accounts/users/' + userId + '/files';

  var config: any = {};

  if (token !== undefined) {
    config.cancelToken = token;
  }

  return axiosInstance.get(url, config).then((r) => r.data);
}

export function getFile(fileId: string, onProgress?: Function, token?: CancelToken): Promise<AxiosResponse<File>> {
  const url = '/company/files/' + fileId + '/file';

  var config: any = {
    responseType: 'blob',
    onUploadProgress: onProgress,
  };

  if (token !== undefined) {
    config.cancelToken = token;
  }

  return axiosInstance.get(url, config);
}

export function getFileAndDownload(fileId: string, fileName?: string, onProgress?: Function, token?: CancelToken): Promise<File> {
  const url = '/company/files/' + fileId + '/file';

  var config: any = {
    responseType: 'blob',
    onUploadProgress: onProgress,
  };

  if (token !== undefined) {
    config.cancelToken = token;
  }

  return axiosInstance.get(url, config).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    var contentFilename = response.headers['content-disposition'].substring(response.headers['content-disposition'].indexOf('=') + 1);
    link.href = url;
    link.setAttribute('download', fileName ?? contentFilename);
    document.body.appendChild(link);
    link.click();
    return response.data;
  });
}

export function getFileData(fileId: string, token?: CancelToken): Promise<FileUploads> {
  const url = '/company/files/' + fileId;

  var config: any = {};
  if (token !== undefined) {
    config.cancelToken = token;
  }

  return axiosInstance.get(url, config).then((r) => r.data);
}

export function postFile(file: File, fileName: string, onProgress?: Function, token?: CancelToken): Promise<FileUploads> {
  const url = '/company/files';

  var body = new FormData();

  body.append('Files', file);
  body.append('FileName', fileName);

  var config: any = {};
  if (token !== undefined) {
    config.cancelToken = token;
  }
  config.headers = { 'Content-Type': 'multipart/form-data' };
  config.onUploadProgress = onProgress;

  return axiosInstance.post(url, body, config).then((r) => r.data);
}

export function confirmPostFile(fileId: string): Promise<FileUploads> {
  const url = '/company/files/' + fileId;
  return axiosInstance.put(url).then((r) => r.data);
}

export function renameFile(fileId: string, newfileName: string): Promise<FileUploads> {
  const url = '/company/files/' + fileId + '/name?fileName=' + newfileName;
  return axiosInstance.put(url).then((r) => r.data);
}

export function tempDeleteFile(fileId: string): Promise<FileUploads> {
  const url = '/company/files/' + fileId + '/delete';
  return axiosInstance.put(url).then((r) => r.data);
}

export function deleteFile(fileId: string): Promise<FileUploads> {
  const url = '/company/files/' + fileId;
  return axiosInstance.delete(url).then((r) => r.data);
}

/*-------------------------------------Interfaces----------------------------------------------*/

export interface FileUploads extends CreatedUpdatedTable {
  id: number;
  uniqueId: string;
  status: string;
  size?: number;
  type: string;
  userId: string;
  fileName: string;
  fileNickname: string;
  fileExtension: string;
  fileLocation: string;
  creditCardTransactionAssignments: CreditCardTransactionAssignment[];
  expenseReportAssignments: any[];
}
